import { render } from "./Switcher.vue?vue&type=template&id=e4c791d2&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=e4c791d2&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c791d2"],['__file',"src/assets/js/components/Switcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4c791d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4c791d2', __exports__)) {
    api.reload('e4c791d2', __exports__)
  }
  
  module.hot.accept("./Switcher.vue?vue&type=template&id=e4c791d2&scoped=true", () => {
    api.rerender('e4c791d2', render)
  })

}


export default __exports__